import React, { FC, ReactNode, useEffect } from 'react';
import type { Location } from 'react-router-dom';
import { useFoyerConfig, useFoyerConfigDispatch } from './FoyerProvider';
import { isPrerenderRun } from '@/utils';

type FoyerShellProps = {
    children: ReactNode;
    navReady: boolean;
    navRealms: any[]; // type later
    location: Location;
};

const FoyerShell: FC<FoyerShellProps> = ({
    children,
    navReady,
    navRealms,
    location,
}) => {
    const foyerConfig = useFoyerConfig();
    const foyerConfigDispatch = useFoyerConfigDispatch();

    useEffect(() => {
        if (isPrerenderRun()) return;
        if (foyerConfig.initialized) return;
        if (!navReady) return;
        if (!navRealms?.length) return;

        foyerConfigDispatch({
            type: 'INITIALIZE_NAV_AREAS',
            realms: navRealms,
            location,
        });
    }, [
        foyerConfig.initialized,
        navReady,
        navRealms,
        location,
        foyerConfigDispatch,
    ]);

    useEffect(() => {
        foyerConfigDispatch({
            type: 'GO_CURRENT_LOCATION',
            location,
        });
    }, [location, foyerConfigDispatch]);

    return <>{children}</>;
};

export default FoyerShell;
